import { fetchJson } from "@modules/util/fetch-json.ts"
import { getLocationAsString } from "../location/location"
import type { ApiFiltersResult } from "../types"
import { getQueryParametersAsString } from "../util/query-parameter"

let filterApiResult: ApiFiltersResult | undefined
export function createPathForTelephoneSexApi() {
    const location = getLocationAsString()
    const queryParamsString = getQueryParametersAsString()
    const path = [location, "telefonsex"].filter((value) => value.trim().length !== 0)
    return `/${path.join("/")}${queryParamsString}`
}

export async function fetchApi() {
    const [res, err] = await fetchJson(`/api${createPathForTelephoneSexApi()}`)
    if (err && res.error === "CoordinatesNotInSessionException") {
        window.location.href = "/#geoRetry"
        return
    }
    filterApiResult = res
    return filterApiResult
}
